export const getAgentType = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
    const mobilePatterns = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
      /Mobile/i,
      /Opera Mini/i,
      /IEMobile/i
    ];
    
    const isMobile = mobilePatterns.some(pattern => pattern.test(userAgent));
    
    return isMobile ? 'mobile' : 'desktop';
  };
  
  export default getAgentType;
  